// removed by extract-text-webpack-plugin
module.exports = {"theme":"#1989fa"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/variables.scss
// module id = VbAD
// module chunks = 2